<template>
  <detail-page-layout :config="pageConfig">
    <el-table 
    v-loading="IsLoading"
    element-loading-text="加载中"
    :data="[service]">
      <el-table-column label="维修订单">
        <template scope="props">
          {{props.row.OrderCode}}
        </template>
      </el-table-column>
      <el-table-column label="订单来源">
        <template scope="props">
          {{props.row.OriginalOrderType | OrderSource}} <span style="color:#20a0ff;" v-if="props.row.OriginalOrderType != null">({{props.row.OriginalOrderCode}})</span>
        </template>
      </el-table-column>
      <el-table-column label="维修类型">
        <template scope="props">
          {{props.row.RepairType | RepairType}}
        </template>
      </el-table-column>
      <el-table-column label="区域">
        <template scope="props">
          <!-- 维修区域 -->
        </template>
      </el-table-column>
    </el-table>
    <h3 style="line-height: 2em;font-size: 14px;">物料清单</h3>
    <el-table 
      v-loading="IsLoading"
      element-loading-text="加载中"
      :data="servicelist"
      :row-class-name="tableRowClassName">
      <el-table-column label="批次号" width="170">
        <template scope="props">
          {{props.row.LotCode}}
        </template>
      </el-table-column>
      <el-table-column label="物料名称" width="260">
        <template scope="props">
          <el-col>{{props.row.ProductName}}</el-col>
          <el-col>物料编码：{{props.row.ProductCode}}</el-col>
        </template>
      </el-table-column>
      <el-table-column label="物料品项">
        <template scope="props">
          <el-tag type="primary">{{props.row.ConditionName}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="品牌">
        <template scope="props">
          {{props.row.BrandName}}
        </template>
      </el-table-column>
      <el-table-column label="机型">
        <template scope="props">
          {{props.row.ModelName}}
        </template>
      </el-table-column>
      <el-table-column label="模块">
        <template scope="props">
          {{props.row.ModuleName}}
        </template>
      </el-table-column>
      <el-table-column
        label="收货状态"
        v-if="service.State == 'receiving'">
        <template scope="props">
          {{PickingState(props)}}
        </template>
      </el-table-column>
      <el-table-column label="维修原因">
        <template scope="props" >
          <el-button type="text" @click.native="repairreason(props)">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column label="质检结果" v-if="service.State != 'receiving'">
        <template scope="props">
          <el-button type="text" @click.native="resultBox(props.$index)" 
            v-if="service.State != 'qc' && 
            service.State != 'draft'&& 
            service.State != 'receiving'">查看</el-button>
          <span v-else>－</span>
        </template>
      </el-table-column>
      <el-table-column
        label="维修费用" v-if="service.State == 'repairing'">
        <template scope="props">
          ¥{{props.row.RepairAmount}}
        </template>
      </el-table-column>
      <el-table-column label="维修结果" v-if="service.State == 'finished'">
        <template scope="props">
          {{ props.row.RepairOrderLineResult | RepairLotResult }}
        </template>
      </el-table-column>
      <el-table-column label="状态" v-if="service.State == 'finished'">
        <template scope="props">
          {{itemState(props)}}
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="维修原因"  size="small" class="pop-box" v-model="repairReasonFormVisible">
      <p>{{repairReason}}</p>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="repairReasonFormVisible = false">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog title="质检结果"  size="large" class="pop-box review-table" v-model="resultFormVisible" v-if="">
        <h5>批次清单</h5>
        <table>
          <thead>
            <tr>
              <td>批次号</td>
              <td>物料名称</td>
              <td>物料品项</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{qcLines.Lot.Code}}</td>
              <td>
                {{qcLines.Product.Name}}<br>
                物料编码：{{qcLines.Product.Code}}
              </td>
              <td><el-tag type="primary">{{qcLines.Condition.Name}}</el-tag></td>
            </tr>
          </tbody>
        </table>
        <p>检测建议：{{qcLines.Suggestion | SuggestionChange}}</p>
        <p>质检报告：{{qcLines.Report}}</p>
        <h5>维修配件</h5>
        <div class="replacement" v-for="item in qcLines.PartsProcurementLines">
          <el-row >
            <el-col :span="8">
              物料名称
              <span>{{item.Product.Name}}</span>
            </el-col>
            <el-col :span="8">
              物料编码
              <span>{{item.Product.Code}}</span>
            </el-col>
            <el-col :span="8">
              数量
              <span>{{item.Quantity}}</span>
            </el-col>
          </el-row>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="resultFormVisible = false">确认</el-button>
        </div>
      </el-dialog>
  </detail-page-layout>
</template>

<script>
import DetailPageLayout from '@/components/common/DetailPageLayout'
import o from '@/odata'
export default {
  mounted() {
    this.initServices()
  },
  data() {
    return {
      repairReasonFormVisible: false,
      resultFormVisible: false,
      repairReason: '',
      pageConfig: {
        StepsBarEnabled: true,
        Steps: [
          {key: 'draft', title: '待确认'},
          {key: 'receiving', title: '待收货'},
          {key: 'qc', title: '待质检'},
          {key: 'review', title: '待复核'},
          {key: 'repair', title: '维修中'},
          {key: 'finished', title: '已完成'},
        ],
        Step: 6,
        Breadcrumbs: [
          {
            to: {name: 'RepairList'},
            name: '维修订单列表',
          },
          {
            name: '维修订单详情',
          },
        ],
      },
      defaultSteps: [
        {key: 'draft', title: '待确认'},
        {key: 'receiving', title: '待收货'},
        {key: 'qc', title: '待质检'},
        {key: 'review', title: '待复核'},
        {key: 'repair', title: '维修中'},
        {key: 'finished', title: '已完成'},
      ],
      service: {},
      servicelist: [],
      qcLines: {
        Lot: {},
        Product: {},
        Condition: {},
      },
      qcdetail: [],
      IsLoading: false,
    }
  },
  methods: {
    /* 判断此行是否高亮 */
    tableRowClassName(row, rowIndex) {
      const selectedRepairLine = window.localStorage.getItem('selectedRepairLine')
      if ((row.RepairOrderLineId + '') === selectedRepairLine) {
        return 'selected-row'
      }
      return ''
    },
    PickingState: function(props) {
      if (props.row.InStockPickingState === 'confirmed') {
        return '已确认'
      } else if (props.row.InStockPickingState === 'shipped') {
        return '未确认'
      } else if (props.row.InStockPickingState === 'reserved') {
        return '已收货'
      } else if (props.row.InStockPickingState === 'qc') {
        return '待质检'
      } else if (props.row.InStockPickingState === 'review') {
        return '待复核'
      } else if (props.row.InStockPickingState === 'finished') {
        return '完成'
      } else if (props.row.InStockPickingState === 'cancelled') {
        return '取消'
      }
    },
    itemResult: function(props) {
      if (props.row.State !== 'repair') {
        return '已修复'
      } else {
        return '未修复'
      }
    },
    itemState: function(props) {
      if (props.row.State === 'waitting') {
        return '等待维修处理'
      } else if (props.row.State === 'instock') {
        return '入库'
      } else if (props.row.State === 'sendBack') {
        return '寄回'
      } else if (props.row.State === 'scrap') {
        return '报废'
      } else if (props.row.State === 'external') {
        return '委外维修'
      } else if (props.row.State === 'repair') {
        return '内部维修'
      }
    },
    resultBox: function(index) {
      if (this.service.QcOrderId != null) {
        this.qcLines = {}
        this.resultFormVisible = true
        this.qcLines = this.qcdetail[index]
      } else {
        this.$message({
          message: '没找到质检单号',
          type: 'info',
        })
      }
    },
    repairreason: function(props) {
      this.repairReasonFormVisible = true
      this.repairReason = props.row.RepairReason
    },
    initServices: function() {
      this.IsLoading = true
      const Services = o('RepairOrder(' + this.$route.params.id + ')/Services.GetDetail()')
      Services.get().then((response) => {
        this.IsLoading = false
        this.service = response.data
        this.servicelist = response.data.Lines
        this.updateSteps(response.data.State)
        // if (this.service.State === 'receiving') {
        //   this.pageConfig.Step = 1
        // } else if (this.service.State === 'qc') {
        //   this.pageConfig.Step = 2
        // } else if (this.service.State === 'review') {
        //   this.pageConfig.Step = 3
        // } else if (this.service.State === 'repairing') {
        //   this.pageConfig.Step = 4
        // } else if (this.service.State === 'finished') {
        //   this.pageConfig.Step = 5
        // }
        this.initqc()
      }).catch((response) => {
        this.IsLoading = false
      })
    },
    updateSteps(State) {
      switch (State) {
        case 'draft':
          this.$set(this.pageConfig, 'Steps', this.defaultSteps)
          this.$set(this.pageConfig, 'Step', 1)
          break
        case 'receiving':
          this.$set(this.pageConfig, 'Steps', this.defaultSteps)
          this.$set(this.pageConfig, 'Step', 2)
          break
        case 'qc':
          this.$set(this.pageConfig, 'Steps', this.defaultSteps)
          this.$set(this.pageConfig, 'Step', 3)
          break
        case 'review':
          this.$set(this.pageConfig, 'Steps', this.defaultSteps)
          this.$set(this.pageConfig, 'Step', 4)
          break
        case 'repairing':
          this.$set(this.pageConfig, 'Steps', this.defaultSteps)
          this.$set(this.pageConfig, 'Step', 5)
          break
        case 'finished':
          this.$set(this.pageConfig, 'Steps', this.defaultSteps)
          this.$set(this.pageConfig, 'Step', 6)
          break
        case 'cancelled':
          this.$set(this.pageConfig, 'Steps', [this.defaultSteps[0], { key: 'fail', title: '已取消', state: 'failure' }])
          this.$set(this.pageConfig, 'Step', 2)
          break
      }
    },
    initqc: function() {
      const id = this.service.QcOrderId
      o('QcOrder').find(id).expand(`Principal($select=Name)`).expand(`Partner($select=Id,Code,Name)`).expand(`RepairOrder($select=Id,Code)`).expand(`Lines($expand=Product,Condition,PartsProcurementLines($expand=Product($select=Code,Name)),Lot($select=Id,Code))`).get().then(({ data }) => {
        this.qcdetail = data.Lines
        this.qcLines = this.qcdetail[0]
      }).catch((response) => {})
    },
  },
  components: {
    DetailPageLayout,
  },
  filters: {
    SuggestionChange: function(value) {
      if (value === 'internal') {
        return ' 内部维修'
      } else if (value === 'external') {
        return '外部维修'
      } else if (value === 'ok') {
        return '无需维修'
      } else {
        return value
      }
    },
  },
}
</script>

<style lang="less" scoped>
.red{
  color: #FF4949;
}

.demo-table-expand{
  .el-form-item{
    width: 24%;
     margin-bottom: 0;
    margin-right: 0;
    span{
      font-size: 14px;
      color: #1F2D3D;
    }
    .span-blue{
      color: #20A0FF;
    }
  }
}

h3{
  color: #354052;
  font-size: 24px;
  margin:20px 0 10px;
  span{
    font-size: 20px;
    color: #A6AFB7;
    font-weight: normal;
  }
}
.pop-box .el-dialog--large{
  width: 80%;
}
.el-table__expanded-cell{
  background: #F5F7FA;
  box-shadow: inset 0 0 0 0 #E0E6ED, inset 0 0 0 1px #E0E6ED;
}
.el-dialog__body .el-form{
  padding-bottom: 20px;
}
.pop-box p.pull-left{
  font-size: 14px;
  color: #7F8FA4;
}

.list-box{
  h4{
    margin-bottom: 25px;
    .el-button{
      margin-top: -5px;
      margin-right: 15px;
    }
  }
}
.chose-box{
  margin-bottom: 20px;
  .chose-item{
    margin-right: 20px;
    display: inline-block;
    p{
      margin-bottom: 5px;
      font-size: 14px;
      color: #7F8FA4;
    }
  }
}
.replacement{
  background: #FEFEFE;
  border: 1px solid #BCCCDA;
  border-radius: 4px;
  padding: 15px 20px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #7F8FA4;
}
.replacement span{
  color: #354052;
  margin-left: 20px;
}
.review-table{
  padding-bottom: 30px;
  border-bottom: 1px solid #E0E6ED;
  h5{
    font-size: 18px;
    color: #7F8FA4;
    margin: 0 0 10px;
  }
  
  td{
    padding: 15px;
  }
  table thead td{
    background: #E5E9F2;
    box-shadow: inset 0 1px 0 0 #E0E6ED, inset 1px 0 0 0 #E0E6ED, inset 0 -1px 0 0 #E0E6ED;
  }
  tbody{
    background: #FFFFFF;
    box-shadow: inset 0 0 0 0 #E0E6ED, inset 0 0 0 1px #E0E6ED;
  }
}
.pop-box.review-table{
  table{
    margin-bottom: 30px;
  }
  table tbody td{
    border-bottom:1px solid #E0E6ED;
  }
}
table{
  width: 100%;
  border-collapse: collapse;
}
</style>
<style lang="less">
/* 由维修支出报表跳转过来的批次高亮效果*/
.selected-row{
  background: #c9e5f5 !important;
}
</style>




// WEBPACK FOOTER //
// RepairDetailPage.vue?a63746e6